import type {TableType, modeType} from '@smart/editorial-components';
import {Table} from '@smart/editorial-components';
import type {TableContent} from '@smart/website-aem-utils';
import {createLegalDisclaimerProps} from '@smart/website-aem-utils';
import * as React from 'react';
import {useFeatureServices} from '../hooks/use-feature-services';
import {useLink} from '../hooks/use-link';
import {PageModelContext} from './page';

export interface TableWrapperProps {
  readonly content: TableContent;
}

export const TableWrapper = React.memo<TableWrapperProps>(
  ({content}) => {
    const {historyService} = useFeatureServices();
    const pageModel = React.useContext(PageModelContext);
    const {languageTag = ``, marketId = ``} = pageModel?.locale || {};
    const props: TableType = {
      removeTopSpacing: content.removeTopSpacing || false,
      mode: content.mode as modeType,
      subline: content.subline,
      headline: content.headline,
      layoutAlign: content.layoutAlign,
      hasHeaderRow: content.hasHeaderRow || false,
      hasHeaderColumn: content.hasHeaderColumn || false,
      headerRow: content.headerRow,
      headerColumn: content.headerColumn,
      dataSource: content.dataSource,
      disclaimers:
        (content.disclaimers &&
          createLegalDisclaimerProps(content.disclaimers, historyService)) ||
        [],
      link: useLink(content.link, {
        websiteTrackingData: {
          type: `navigation`,
          region: `table`,
          name: content.link?.label || ``,
        },
        languageTag,
        marketId,
      }),
    };

    return <Table {...props} />;
  },
  (prevProps, nextProps) => prevProps.content.id === nextProps.content.id,
);

Table.displayName = `Table`;
